<!-- ── Page header ────────────────────────────────────────────────────────────── -->
<section class="tg-page-hero">
  <div class="tg-container">
    <h1 class="tg-page-hero__title">Planes</h1>
    <p class="tg-page-hero__sub">Elige el plan que mejor se adapte a tu búsqueda de empleo</p>
    <ul class="tg-page-hero__breadcrumb">
      <li><a routerLink="/">Inicio</a></li><li>›</li><li>Planes</li>
    </ul>
  </div>
</section>

<section style="background:#f9fafb;padding:60px 0 80px;">
  <div class="tg-container">

    <!-- Ya eres Premium -->
    <div *ngIf="isPremium"
         style="max-width:560px;margin:0 auto;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:16px;padding:32px;text-align:center;">
      <div style="font-size:2.5rem;margin-bottom:12px;">🎉</div>
      <h2 style="color:#15803d;font-size:1.4rem;font-weight:700;margin:0 0 8px;">¡Eres usuario Premium!</h2>
      <p style="color:#166534;font-size:14px;margin:0 0 20px;">Tienes alertas de vacantes ilimitadas y acceso a WhatsApp en tiempo real.</p>
      <a routerLink="/mis-alertas"
         style="display:inline-block;background:#16a34a;color:#fff;padding:10px 28px;border-radius:8px;text-decoration:none;font-weight:600;font-size:14px;">
        Configurar alertas
      </a>
    </div>

    <!-- Planes side-by-side -->
    <div *ngIf="!isPremium"
         style="display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:24px;max-width:720px;margin:0 auto;">

      <!-- Plan Free -->
      <div style="background:#fff;border:1px solid #e5e7eb;border-radius:16px;padding:32px;">
        <div style="font-size:12px;font-weight:700;color:#6b7280;letter-spacing:.5px;text-transform:uppercase;margin-bottom:8px;">Free</div>
        <div style="font-size:2.5rem;font-weight:800;color:#111827;line-height:1;">$0
          <span style="font-size:1rem;font-weight:400;color:#9ca3af;">/mes</span>
        </div>
        <p style="color:#6b7280;font-size:14px;margin:12px 0 24px;">Para empezar tu búsqueda</p>
        <ul style="list-style:none;padding:0;margin:0 0 28px;display:flex;flex-direction:column;gap:10px;">
          <li style="display:flex;align-items:center;gap:8px;font-size:14px;color:#374151;">
            <span style="color:#22c55e;font-weight:700;">✓</span> GuruMatch con tu CV
          </li>
          <li style="display:flex;align-items:center;gap:8px;font-size:14px;color:#374151;">
            <span style="color:#22c55e;font-weight:700;">✓</span> 2 alertas por email / mes
          </li>
          <li style="display:flex;align-items:center;gap:8px;font-size:14px;color:#374151;">
            <span style="color:#22c55e;font-weight:700;">✓</span> Acceso a vacantes del mercado
          </li>
          <li style="display:flex;align-items:center;gap:8px;font-size:14px;color:#9ca3af;">
            <span style="font-weight:700;">✗</span> Alertas WhatsApp en tiempo real
          </li>
          <li style="display:flex;align-items:center;gap:8px;font-size:14px;color:#9ca3af;">
            <span style="font-weight:700;">✗</span> Optimizador IA de CV (1/día Premium)
          </li>
        </ul>
        <div style="background:#f3f4f6;border-radius:8px;padding:12px;text-align:center;font-size:13px;color:#6b7280;font-weight:500;">
          Tu plan actual
        </div>
      </div>

      <!-- Plan Premium -->
      <div style="background:linear-gradient(135deg,#1d4ed8,#1e40af);border-radius:16px;padding:32px;position:relative;overflow:hidden;">
        <div style="position:absolute;top:-20px;right:-20px;width:100px;height:100px;border-radius:50%;background:rgba(255,255,255,.07)"></div>
        <div style="font-size:12px;font-weight:700;color:#93c5fd;letter-spacing:.5px;text-transform:uppercase;margin-bottom:8px;">Premium</div>

        <!-- Monthly / Annual toggle -->
        <div style="display:flex;gap:6px;margin-bottom:16px;">
          <button (click)="plan='monthly'"
                  [style.background]="plan==='monthly' ? '#fff' : 'rgba(255,255,255,.15)'"
                  [style.color]="plan==='monthly' ? '#1d4ed8' : '#93c5fd'"
                  style="flex:1;border:none;border-radius:8px;padding:6px 10px;font-size:12px;font-weight:600;cursor:pointer;transition:.15s;">
            Mensual
          </button>
          <button (click)="plan='annual'"
                  [style.background]="plan==='annual' ? '#fff' : 'rgba(255,255,255,.15)'"
                  [style.color]="plan==='annual' ? '#1d4ed8' : '#93c5fd'"
                  style="flex:1;border:none;border-radius:8px;padding:6px 10px;font-size:12px;font-weight:600;cursor:pointer;transition:.15s;">
            Anual &nbsp;<span style="background:#fbbf24;color:#78350f;border-radius:4px;padding:1px 5px;font-size:10px;">−17%</span>
          </button>
        </div>

        <div style="font-size:2.5rem;font-weight:800;color:#fff;line-height:1;">
          {{ plan === 'annual' ? '$3,490' : '$349' }}
          <span style="font-size:1rem;font-weight:400;color:#93c5fd;">MXN / {{ plan === 'annual' ? 'año' : 'mes' }}</span>
        </div>
        <p style="color:#bfdbfe;font-size:13px;margin:6px 0 4px;">
          {{ plan === 'annual' ? 'Equivale a $291 MXN/mes · ahorras $698/año' : 'Se renueva mensualmente · cancela cuando quieras' }}
        </p>
        <p style="color:#93c5fd;font-size:11px;margin:0 0 8px;">
          Compradores internacionales: Stripe convierte automáticamente a tu moneda local.
        </p>
        <p style="color:#6ee7b7;font-size:14px;margin:0 0 20px;font-weight:600;">Para candidatos que van en serio</p>

        <ul style="list-style:none;padding:0;margin:0 0 28px;display:flex;flex-direction:column;gap:10px;">
          <li style="display:flex;align-items:center;gap:8px;font-size:14px;color:#fff;">
            <span style="color:#86efac;font-weight:700;">✓</span> Todo lo del plan Free
          </li>
          <li style="display:flex;align-items:center;gap:8px;font-size:14px;color:#fff;">
            <span style="color:#86efac;font-weight:700;">✓</span> Alertas de vacantes ilimitadas
          </li>
          <li style="display:flex;align-items:center;gap:8px;font-size:14px;color:#fff;">
            <span style="color:#86efac;font-weight:700;">✓</span> Alertas por WhatsApp en tiempo real
          </li>
          <li style="display:flex;align-items:center;gap:8px;font-size:14px;color:#fff;">
            <span style="color:#86efac;font-weight:700;">✓</span> Optimizador IA de CV (1/día Premium)
          </li>
          <li style="display:flex;align-items:center;gap:8px;font-size:14px;color:#fff;">
            <span style="color:#86efac;font-weight:700;">✓</span> Cancela cuando quieras
          </li>
        </ul>

        <!-- Error -->
        <p *ngIf="error" style="color:#fca5a5;font-size:13px;margin:0 0 12px;">{{error}}</p>

        <button (click)="suscribir()" [disabled]="loading"
                style="width:100%;padding:14px;background:#fff;color:#1d4ed8;border:none;border-radius:10px;font-size:15px;font-weight:700;cursor:pointer;transition:.2s;">
          {{ loading ? 'Redirigiendo...' : (plan === 'annual' ? 'Suscribirme por $3,490 MXN/año →' : 'Suscribirme por $349 MXN/mes →') }}
        </button>
        <p style="color:#93c5fd;font-size:11px;text-align:center;margin:10px 0 0;">
          Pago seguro con Stripe · Se renueva automáticamente · Cancela en cualquier momento
        </p>
      </div>
    </div>

    <!-- FAQ -->
    <div style="max-width:640px;margin:48px auto 0;">
      <h3 style="font-size:1.1rem;font-weight:700;color:#111827;margin-bottom:20px;text-align:center;">Preguntas frecuentes</h3>
      <div style="display:flex;flex-direction:column;gap:14px;">
        <details style="background:#fff;border:1px solid #e5e7eb;border-radius:10px;padding:14px 18px;">
          <summary style="font-weight:600;font-size:14px;color:#111827;cursor:pointer;">¿Cómo funciona GuruMatch?</summary>
          <p style="margin:10px 0 0;font-size:13px;color:#6b7280;line-height:1.6;">
            Nuestro motor de inteligencia artificial, diseñado por Tec Gurus, analiza tu CV activo y lo compara con cada vacante para calcular un porcentaje de compatibilidad real. Sube tu CV en "Mis CVs" para activarlo.
          </p>
        </details>
        <details style="background:#fff;border:1px solid #e5e7eb;border-radius:10px;padding:14px 18px;">
          <summary style="font-weight:600;font-size:14px;color:#111827;cursor:pointer;">¿Cuándo se envían las alertas?</summary>
          <p style="margin:10px 0 0;font-size:13px;color:#6b7280;line-height:1.6;">
            Nuestro motor de inteligencia artificial, diseñado por Tec Gurus, analiza diariamente las nuevas vacantes. Si encuentra oportunidades con ≥70% de compatibilidad con tu perfil, recibirás una notificación por email o WhatsApp según tu plan.
          </p>
        </details>
        <details style="background:#fff;border:1px solid #e5e7eb;border-radius:10px;padding:14px 18px;">
          <summary style="font-weight:600;font-size:14px;color:#111827;cursor:pointer;">¿Puedo cancelar mi suscripción?</summary>
          <p style="margin:10px 0 0;font-size:13px;color:#6b7280;line-height:1.6;">
            Sí, puedes cancelar en cualquier momento desde tu cuenta de Stripe. Tu acceso Premium se mantiene hasta el fin del período pagado.
          </p>
        </details>
      </div>
    </div>

  </div>
</section>
